module.exports = __webpack_public_path__ + "img/honour-pic-3.37ccd55c.png";